import { render } from "./chartB.vue?vue&type=template&id=6da1b9c6"
import script from "./chartB.vue?vue&type=script&lang=ts"
export * from "./chartB.vue?vue&type=script&lang=ts"
script.render = render

export default script